require('../bootstrap');

import '../plugins'
import Vue from 'vue'
import vuetify from './plugins/vuetify'
import toast from './plugins/Toast'
import * as VueGoogleMaps from 'vue2-google-maps'
import store from "./store";

import ActivationDashboard from './views/analyses/ActivationDashboard';
import MyAudiences from './views/analyses/MyAudiences';
import CohortsManagement from './views/analyses/CohortsManagement';
import PoiLocation from "./views/analyses/PoiLocation";
import ActivationScheduler from "./views/analyses/ActivationScheduler";
import NotificationsModal from "./components/notifications/NotificationsModal";
import NotificationsIcon from "./components/notifications/NotificationsIcon";
import UserNotifications from "./views/Logs/UserNotifications";
import PoiSubmissions from "./views/MyData/Poi/PoiSubmissions";
import MyPois from "./views/MyData/Poi/MyPois";
import Taxonomies from "./views/MyData/Poi/Taxonomies";
import TaxonomiesMap from "./views/MyData/Poi/TaxonomiesMap";
import ActivationReport from "./views/analyses/ActivationReport";
import AKGContracts from "./views/analyses/AKGContracts";

Vue.component('activation-dashboard', ActivationDashboard)
Vue.component('private-audiences', MyAudiences)
Vue.component('cohorts-management', CohortsManagement)
Vue.component('activation-scheduler', ActivationScheduler)
Vue.component('poi-location', PoiLocation)
Vue.component('notifications-modal', NotificationsModal)
Vue.component('notifications-icon', NotificationsIcon)
Vue.component('user-notifications', UserNotifications)
Vue.component('poi-submissions', PoiSubmissions)
Vue.component('my-pois', MyPois)
Vue.component('taxonomies', Taxonomies)
Vue.component('taxonomies-map', TaxonomiesMap)
Vue.component('activation-report', ActivationReport)
Vue.component('akg-contracts', AKGContracts)

Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyB3QiI-F9qWXrVKSdKHR1pgK-eoWxhSQxU'
    }
})

Vue.config.devtools = true

new Vue({
    vuetify,
    toast,
    store,
    el: '#app',
    name: 'Frontend App'
});